import React, { useState } from "react";
import styled from "styled-components";
import { func } from "prop-types";
import storage from "local-storage-fallback";
import SuperCarersOperations from "logic/SuperCarersOperations";
import {
  validateCustomerEmail,
  validateMembershipNumber
} from "components/care_solved/careSolvedHelper";
import Button from "components/shared/Button";
import Copy from "components/shared/Copy";
import Input from "components/shared/Input";
import VitalityLogo from "media/logos/vitality-logo.svg";
import { phoneLink } from "global/analytics";

const FormWrapper = styled.div`
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 0.5rem 1rem 0.5rem;
  border-radius: 5px;
`;

const StyledLogo = styled.img`
  height: 50px;
  margin: 1rem 0 0.5rem;
`;

const LoginPortal = ({ setLogInDetails }) => {
  const [email, updateEmail] = useState("");
  const [membershipNumber, updateMembershipNumber] = useState("");
  const [emailError, setEmailErrorState] = useState(false);
  const [memberError, setMemberErrorState] = useState(false);
  const [submissionError, setSubmissionErrorState] = useState(false);

  const handleChange = e => {
    if (e.target.id === "email") {
      updateEmail(e.target.value);
      if (!validateCustomerEmail(e.target.value)) {
        setEmailErrorState(false);
      }
    }
    if (e.target.id === "membership-number") {
      updateMembershipNumber(e.target.value);
      if (!validateMembershipNumber(e.target.value)) {
        setMemberErrorState(false);
      }
    }
  };

  const validateField = e => {
    if (e.target.id === "email") {
      setEmailErrorState(validateCustomerEmail(e.target.value));
    }
    if (e.target.id === "membership-number") {
      setMemberErrorState(validateMembershipNumber(e.target.value));
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      await SuperCarersOperations.addVitalityMember(email, membershipNumber);
      storage.setItem("cs-portal", JSON.stringify({ email, membershipNumber }));
      setLogInDetails({ email, membershipNumber });
    } catch (error) {
      if (error.response) {
        setSubmissionErrorState(error.response.data.message);
      } else {
        console.info("An error occurred: ", error);
        setSubmissionErrorState(
          <>
            Something went wrong. Please call us on{" "}
            {phoneLink("808 196 0909", { color: "inherit" })}.
          </>
        );
      }
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <FormWrapper>
        <StyledLogo src={VitalityLogo} alt="vitality logo" />
        <Copy color="formText" size={1}>
          Access your Vitality benefits
        </Copy>
        <Copy size={0.8}>Submit an enquiry online,</Copy>
        <Copy margin="0 0 1rem" size={0.8}>
          tell us about your needs
        </Copy>
        <Input
          border="1px solid lightgray"
          id="membership-number"
          onChange={handleChange}
          onBlur={validateField}
          placeholder="Vitality Membership Number"
        />
        <Input
          border="1px solid lightgray"
          id="email"
          onBlur={validateField}
          onChange={handleChange}
          placeholder="Email address"
        />
        <Button
          background="viPink"
          disabled={
            !!emailError || !!memberError || !email || !membershipNumber
          }
          label="Enter"
          margin="1rem 0 0"
          type="submit"
          width="200px"
        />
        {!!emailError && (
          <Copy color="statusRed" size={0.6}>
            * {emailError}
          </Copy>
        )}
        {!!memberError && (
          <Copy color="statusRed" size={0.6}>
            * {memberError}
          </Copy>
        )}
        {!!submissionError && (
          <Copy color="statusRed" size={0.6}>
            * {submissionError}
          </Copy>
        )}
      </FormWrapper>
    </form>
  );
};

LoginPortal.propTypes = {
  setLogInDetails: func.isRequired
};

export default LoginPortal;
